// axiosInstance.js
import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_PREFIX,
});

let isAlreadyLoggingOut = false;

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    
    if (
     error?.response?.status === 401
    ) {
      if (!isAlreadyLoggingOut) {
        isAlreadyLoggingOut = true;
        localStorage.removeItem("token");
        window.location.assign("/auth/login-page");
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
